import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import * as rx from "rxjs";

import type {
  DashTrialNotificationsLastSeen,
  Service,
} from "@mirage/service-dash-trial/service";
import { Observable } from "rxjs";
import type { DashTrialInfo } from "./service/utils";

export const service = services.get<Service>(ServiceId.DASH_TRIAL_INFO);

export function getDashTrialInfo(options?: {
  fetchAllData?: boolean;
}): Promise<DashTrialInfo | undefined> {
  return rx.firstValueFrom(service.getDashTrialInfo(options));
}

export function getCurrentDashTrialInfo(): Observable<
  DashTrialInfo | undefined
> {
  return service.getCurrentDashTrialInfo();
}

export function startSyncDashTrialInfo(): Promise<void> {
  return rx.firstValueFrom(service.startSyncDashTrialInfo());
}

export function getDashTrialNotificationsLastSeen(): Promise<
  DashTrialNotificationsLastSeen | undefined
> {
  return rx.firstValueFrom(service.getDashTrialNotificationsLastSeen());
}

export function setDashTrialNotificationsLastSeen(
  lastSeen: DashTrialNotificationsLastSeen,
): Promise<void> {
  return rx.firstValueFrom(service.setDashTrialNotificationsLastSeen(lastSeen));
}
